import React from "react";
import { View, KeyboardAvoidingView, Text, StyleSheet } from "react-native";

import moment from "moment";

import SnoozeCardsFabButton from "./SnoozeCardsFabButton";
import Search from "../common/search-bar/Search";
import AppTheme from "../AppTheme";
import appStyles from "../../appStyles";
import Utils, { hasItems, navigate } from "../../../helpers/utils";
import Header from "../common/header/index";
import { buildCards } from "./CardItems";
import SnoozeOptions from "../common/SnoozeOptions";

export default class SnoozedCardsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      snoozedCards: [],
      cards: [],
      type: props.type || "sent",
      filterMode: false,
      snoozedCardProxy: null,
      snoozeY: null,
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.componentDidFocus();
        },
      );
    } else {
      this.componentDidFocus();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  componentDidFocus = async () => {
    this.loadCards();
  };

  snoozeCard = (cardUtils, e) => {
    const y = e.clientY || e.nativeEvent?.pageY;
    this.setState((state) => ({
      ...state,
      snoozedCardProxy: cardUtils,
      snoozeY: y,
    }));

    this.loadCards();
  };

  loadCards = async () => {
    const cardItems = this.controller.state.cards_v2 || [];
    const snoozedCards = this.controller.state.snoozed_cards || [];
    const filteredCards = [];
    cardItems.forEach((c) => {
      const snooze = snoozedCards[c.card_id];
      if (snooze) {
        c.snooze_date = snooze.snooze_date;
        c.snooze_date_end = snooze.snooze_date_end;
        filteredCards.push(c);
      }
    });

    const cards = this.sortCards(filteredCards);
    this.setState((state) => ({
      ...state,
      snoozedCards: cards,
      cards: cards,
    }));
  };

  sortCards = (cards) => {
    if (cards) {
      cards.sort((a, b) => {
        const ra_date = moment(a.snooze_date).unix();
        const rb_date = moment(b.snooze_date).unix();

        if (ra_date != rb_date) {
          return ra_date > rb_date ? -1 : 1;
        }

        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
      });
    }

    return cards;
  };

  // ------------------------------------- FILTER -------------------------------------
  filterResults = ({ term }) => {
    let filteredCards = [...this.state.snoozedCards];

    // Multi terms search
    if (term) {
      const pattern = Utils.getSearchPattern(term);

      filteredCards = filteredCards.filter((r) => {
        return (
          (r.name && r.name.match(pattern)) ||
          (r.type && r.type.match(pattern)) ||
          (r.description && r.description.match(pattern))
        );
      });
    }

    this.setState((state) => ({
      ...state,
      isLoading: false,
      cards: [...filteredCards],
    }));
  };

  goBack = () => {
    const { filterMode } = this.state;

    if (filterMode) {
      this.setState((state) => ({ ...state, filterMode: false }));
    } else {
      navigate(this.controller, "rn:home_card");
    }
  };

  viewFeed = () => {
    const navigation = this.props.navigation;
    navigation.navigate("feed");
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      cards,
      users,
      mariMessage,
      type,
      filterMode,
      snoozedCardProxy,
      snoozeY,
    } = this.state;

    const cardsV2 = [];
    buildCards(this.controller, cards, cardsV2, {
      showManaMindful: null,
      isSnoozed: true,
      onSnooze: this.snoozeCard,
    });

    return (
      <View
        style={[appStyles.container, { backgroundColor: AppTheme.containerBg }]}
      >
        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          behavior="height"
        >
          <Header goBack={this.goBack} title="Snoozed Cards" />

          {hasItems(cardsV2) ? (
            cardsV2
          ) : (
            <View style={styles.noResults}>
              <Text>No cards found</Text>
            </View>
          )}

          <View style={[appStyles.footerOptions, { bottom: 16 }]}>
            <SnoozeCardsFabButton
              selectedType={type}
              style={{ bottom: 50 }}
              viewFeed={this.viewFeed}
              mariOptions={{
                mariMessage: mariMessage,
              }}
            />

            <Search
              showIcon={false}
              placeholder="Search Cards"
              filterResults={(text) => this.filterResults(text)}
              inputStyle={{ backgroundColor: "#FFF" }}
              controller={this.controller}
            />
          </View>
        </KeyboardAvoidingView>

        {snoozedCardProxy ? (
          <SnoozeOptions
            style={{ marginBottom: 16 }}
            showSnoozed={true}
            snoozeY={snoozeY}
            onSnooze={(option) => {
              snoozedCardProxy.snoozeCard(option);
              this.setState((state) => ({
                ...state,
                snoozedCardProxy: null,
              }));
              this.loadCards();
            }}
          />
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  noResults: {
    height: 40,
    marginTop: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 10,
  },
});
